<template>
  <div v-if="company != null && businessAddress != null" 
    class="border-2 border-gray-800">
    <div class="overflow-hidden text-base bg-gray-800 text-white px-4 py-3">
      <div class="float-left">
        Principal place of business
      </div>

      <div class="float-left ml-12">
        <input type="checkbox" 
          :checked="company.sameAsRegistered"
          v-on:change="isPrincipalSameAsRegistered($event.target.checked)"
          id="inputIsPrincipalSameAsRegistered"
          value="1" />
        <label for="inputIsPrincipalSameAsRegistered"
          class="ml-2 text-sm">This is same as registered address</label>
      </div>
    </div>

    <div class="p-4">
      <div class="flex flex-wrap">
        <div class="w-full lg:w-1/3 pr-0 lg:pr-3 flex flex-wrap">
          <div class="w-1/3 pr-2">
            <BuildingTypeSelector
              propertyKey="building_type"
              objectType="address"
              :objectId="businessAddress.id"
              :value="businessAddress.building_type"
              :updateValue="updateValue"
              :disabled="company.sameAsRegistered == 1" />
          </div>

          <div class="w-1/3 pr-2">
            <InputText 
              label="Unit number"
              propertyKey="unit_number"
              objectType="business"
              :objectId="businessAddress.id"
              :value="businessAddress.unit_number"
              :updateValue="updateValue"
              :disabled="company.sameAsRegistered == 1" />
          </div>

          <div class="w-1/3">
            <InputText 
              label="Street number"
              propertyKey="street_number"
              objectType="business"
              :objectId="businessAddress.id"
              :value="businessAddress.street_number"
              :updateValue="updateValue"
              :disabled="company.sameAsRegistered == 1" />
          </div>
        </div>

        <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0 flex flex-wrap">
          <div class="w-3/4 pr-2">
            <InputText 
              label="Street name"
              propertyKey="street_name"
              objectType="business"
              :objectId="businessAddress.id"
              :value="businessAddress.street_name"
              :updateValue="updateValue"
              :disabled="company.sameAsRegistered == 1" />

            <div class="mt-1 text-right" v-if="businessAddress.street_name != null && businessAddress.street_name.length > 0">
              <a href="#" class="text-gray-700 hover:underline" @click.prevent="$modal.show('map-modal', { 
                address : getAddressText() 
              })">Show this address on map</a>
            </div>
          </div>

          <div class="w-1/4 pl-1">
            <StreetTypeSelector
              propertyKey="street_type"
              objectType="business"
              :objectId="businessAddress.id"
              :value="businessAddress.street_type"
              :updateValue="updateValue"
              :disabled="company.sameAsRegistered == 1" />
          </div>
        </div>

        <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
          <InputText 
            label="Suburb" 
            objectType="business"
            :objectId="businessAddress.id"
            propertyKey="suburb"
            :value="businessAddress.suburb"
            :updateValue="updateValue"
            :disabled="company.sameAsRegistered == 1" />
        </div>
      </div>
  
      <div class="flex flex-wrap label-line">
        <div class="w-full lg:w-1/3 pr-0 lg:pr-3">
          <InputPostcode 
            label="Postcode" 
            objectType="business"
            :objectId="businessAddress.id"
            propertyKey="postcode"
            :value="businessAddress.postcode"
            :updateValue="updateValue"
            :disabled="company.sameAsRegistered == 1" />
        </div>

        <div class="w-full lg:w-1/3 mt-8 lg:mt-0 pr-0 lg:pr-3">
          <StateSelector
            objectType="business"
            :objectId="businessAddress.id"
            propertyKey="state_id"
            :value="businessAddress.state_id"
            :updateValue="updateValue"
            :disabled="company.sameAsRegistered == 1" />
        </div>

        <div class="w-full lg:w-1/3 pr-0 lg:pr-3 mt-8 lg:mt-0">
          <CountrySelector
            objectType="business"
            :objectId="businessAddress.id"
            propertyKey="country_id"
            :value="businessAddress.country_id"
            :updateValue="updateValue"
            :disabled="company.sameAsRegistered == 1" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>

  import axios                from 'axios'
  import TitleSelector        from '@/shared/components/form/TitleSelector'
  import StateSelector        from '@/shared/components/form/StateSelector'
  import CountrySelector      from '@/shared/components/form/CountrySelector'
  import StreetTypeSelector   from '@/shared/components/form/StreetTypeSelector'
  import BuildingTypeSelector from '@/shared/components/form/BuildingTypeSelector'
  import InputText            from '@/shared/components/form/InputText'
  import InputPostcode        from '@/shared/components/form/InputPostcode'
  import InputEmail           from '@/shared/components/form/InputEmail'
  import { EventBus }         from '@/shared/event-bus';

	export default {

    props : {
      companyId : {
        type    : Number,
        required: true
      },
    },

    components: {
      TitleSelector,
      StateSelector,
      InputText,
      InputEmail,
      CountrySelector,
      StreetTypeSelector,
      BuildingTypeSelector,
      InputPostcode
    },

    data() {
      return {
        company          : null,
        businessAddress  : null,
        registeredAddress: null
      }
    },

    mounted() {
      EventBus.$on('company-registered-address-changed', registeredAddress => {
        this.registeredAddress = registeredAddress
        this.isPrincipalSameAsRegistered(this.company.sameAsRegistered == 1)
      })
    },

    created() {    
      axios.get(process.env.VUE_APP_API_URL + '/api/applicant/company', {
        params : {
          clientId : this.$route.params.clientId,
          companyId: this.companyId,
        },
        headers: {
          'Authorization' : 'Bearer ' + localStorage.getItem('bp-broker-jwt')
        }
      }).then(response => {
        this.company           = response.data.company
        this.businessAddress   = response.data.businessAddress
        this.registeredAddress = response.data.registeredAddress
      }).catch(e => {
      })
    },

		methods : {

      updateValue(params) {
        this.updateAddress(this.businessAddress, params.key, params.value)
      },

      isPrincipalSameAsRegistered(shouldBeSame) {
        if(shouldBeSame) {
          this.businessAddress.unit_number   = this.registeredAddress.unit_number
          this.businessAddress.street_number = this.registeredAddress.street_number
          this.businessAddress.street_name   = this.registeredAddress.street_name
          this.businessAddress.street_type   = this.registeredAddress.street_type
          this.businessAddress.suburb        = this.registeredAddress.suburb
          this.businessAddress.postcode      = this.registeredAddress.postcode
          this.businessAddress.state_id      = this.registeredAddress.state_id
          this.businessAddress.country_id    = this.registeredAddress.country_id
          this.updateAddress(this.businessAddress)
        }

        // update the value
        this.updateCompany(this.company, 'sameAsRegistered', (shouldBeSame ? 1 : 0))
      },
		}
	}
</script>